import Markdown from "markdown-to-jsx";
import styles from "./sectionDiferenctials.module.css";

export default function SectionDiferenctialsFirst({ data }) {
  return (
    <>
      <section className={`container-full ${styles.container}`}>
        <div
          className={`grid-cont align-self-center flex-lg-row flex-column-reverse ${styles.content}`}
        >
          <div className={styles.img}>
            <img src={data.imagem.url} />
          </div>
          <div className={styles.diferentials}>
            {data.diferenciais.map((item) => {
              return (
                <>
                  <div className={styles.difContent}>
                    <div className={styles.difImg}>
                      <img src={item.icone.url} />
                    </div>
                    <div className={styles.diferential}>
                      <div>
                        <h2>{item.titulo}</h2>
                        <Markdown>{item.texto}</Markdown>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
